import ArrModal from '../../../../common/arr-modal/ArrModal';
import {useCallback} from 'react';
import {t} from 'i18next';
import './RedactionMenu.scss';

const enRedactionMenu = 'docView.deleteBatchRedactionPopup';

export interface DeleteBatchRedactionPopupProps {
  closeDeleteBatchRedactionPopup: () => void;
  deleteBatchRedaction: () => void;
  deleteBatchRedactionLabel: string;
}
export const DeleteBatchRedactionPopup = ({
  closeDeleteBatchRedactionPopup,
  deleteBatchRedaction,
  deleteBatchRedactionLabel,
}: DeleteBatchRedactionPopupProps) => {
  const onClose = useCallback(() => {
    closeDeleteBatchRedactionPopup();
  }, [closeDeleteBatchRedactionPopup]);

  const handleDelete = useCallback(() => {
    deleteBatchRedaction();
  }, [deleteBatchRedaction]);

  return (
    <ArrModal
      showModal={true}
      dataTestId="delete-batch-popup"
      headerTitleClassName="headline3_size"
      headerTitle={t(`${enRedactionMenu}.title`)}
      className="save-redaction-single-popup"
      description={
        <>
          {t(`${enRedactionMenu}.descPart1`)} <br data-testid={`delete-batch-redaction-popup-br`} />
          {t(`${enRedactionMenu}.descPart2`)} "{deleteBatchRedactionLabel}"
          {t(`${enRedactionMenu}.descPart3`)}
        </>
      }
      onClose={onClose}
      buttons={[
        {
          id: 'cancel-button',
          label: t('common.cancel'),
          dataTestId: 'dbp-cancel-button',
          onClick: onClose,
          variant: 'secondary',
        },
        {
          id: 'delete-button',
          label: t('common.delete'),
          dataTestId: 'dbp-delete-button',
          onClick: handleDelete,
          variant: 'primary',
        },
      ]}
    ></ArrModal>
  );
};
